/*
 * inselvolt Kompatibilitätsberater — Filter-Facetten (reine Logik).
 *
 * Herausgelöst aus app/berater-ui.js (E6, 2026-08-25): Alles, was am
 * Filterpanel GERECHNET wird, ohne das Zeichnen — testbar ohne DOM.
 * Die Engine wird hereingereicht (filtereErgebnis, herstellerRang), damit das
 * Modul keine Ladereihenfolge über window voraussetzt.
 *
 * Grundsatz der Facetten: Ein Filter, der nichts findet, ist kein Filter —
 * er ist eine Sackgasse. Jede Auswahlmöglichkeit wird gegen den tatsächlichen
 * Ergebnisbestand gezählt (mit allen ANDEREN aktiven Filtern, ohne den
 * betrachteten) und nur angeboten, wenn sie zu Treffern führt. Die aktive
 * Auswahl bleibt immer stehen, damit sie nicht unter den Fingern verschwindet.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.IVBeraterFilterwerk = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function istZahl(x) { return typeof x === 'number' && isFinite(x); }

  /* Die Stufen der Mindest-Entladeleistung — vorher in berater-ui.js. */
  var LEISTUNGS_STUFEN = [
    { id: 'egal', name: 'Alle', titel: 'keine Vorgabe zur Entladeleistung', kw: null },
    { id: 'standard', name: 'ab 3 kW', titel: 'Grundlast und Haushaltsgeräte', kw: 3 },
    { id: 'wp', name: 'ab 7 kW', titel: 'ein Großverbraucher, z. B. Wärmepumpe oder Wallbox', kw: 7 },
    { id: 'hoch', name: 'ab 10 kW', titel: 'mehrere Großverbraucher gleichzeitig', kw: 10 },
  ];

  /* Der leere Filter — eine Quelle für Start UND „Alle zurücksetzen"
   * (vorher zweimal wortgleich in berater-ui.js). */
  function neuerFilter() {
    return {
      hersteller: [],
      leistung: 'egal',
      minKapazitaet: null,
      maxKapazitaet: null,
      maxEurProKwh: null,
      nurVerfuegbar: false,
      spannungsklasse: null,
    };
  }

  /* UI-Filterzustand → Filterobjekt der Engine. Kapazität und €/kWh gibt es
   * nur in der Speicher-Richtung. */
  function engineFilter(filter, modus) {
    var stufe = LEISTUNGS_STUFEN.filter(function (s) { return s.id === filter.leistung; })[0];
    return {
      modus: modus,
      hersteller: filter.hersteller,
      min_entlade_kw: stufe ? stufe.kw : null,
      min_kapazitaet_kwh: modus === 'speicher' ? filter.minKapazitaet : null,
      max_kapazitaet_kwh: modus === 'speicher' ? filter.maxKapazitaet : null,
      max_eur_pro_kwh: modus === 'speicher' ? filter.maxEurProKwh : null,
      spannungsklasse: filter.spannungsklasse,
      nur_verfuegbar: filter.nurVerfuegbar,
    };
  }

  /* Trefferzahl mit einer punktuellen Änderung am aktiven Filter. */
  function zaehleMit(engine, basis, modus, filter, aenderung) {
    var f = engineFilter(filter, modus);
    for (var k in aenderung) {
      if (Object.prototype.hasOwnProperty.call(aenderung, k)) f[k] = aenderung[k];
    }
    return engine.filtereErgebnis(basis, f).length;
  }

  /* Hersteller im Ergebnis, je mit Trefferzahl; angeboten wird, was Treffer
   * hat oder bereits gewählt ist. Sortiert nach Rang (Logo-Hersteller vorn),
   * dann alphabetisch. */
  function herstellerFacette(engine, basis, modus, filter) {
    var namen = [];
    basis.forEach(function (e) {
      if (namen.indexOf(e.hersteller) === -1) namen.push(e.hersteller);
    });
    return namen
      .map(function (h) { return { name: h, treffer: zaehleMit(engine, basis, modus, filter, { hersteller: [h] }) }; })
      .filter(function (h) { return h.treffer > 0 || filter.hersteller.indexOf(h.name) !== -1; })
      .sort(function (a, b) {
        var ra = engine.herstellerRang(a.name);
        var rb = engine.herstellerRang(b.name);
        if (ra !== rb) return ra - rb;
        return String(a.name).localeCompare(String(b.name), 'de');
      });
  }

  /* Vorhandene Spannungsklassen (ohne Angabe gilt hochvolt), sortiert. */
  function spannungsklassenImErgebnis(basis) {
    var klassen = [];
    basis.forEach(function (e) {
      var k = e.spannungsklasse || 'hochvolt';
      if (klassen.indexOf(k) === -1) klassen.push(k);
    });
    return klassen.sort();
  }

  /*
   * Leistungsstufen mit Trefferzahl. Eine Stufe, die genauso viele Treffer
   * liefert wie „Alle", grenzt nichts ein — sie sieht nur nach Auswahl aus.
   * Solche Stufen fliegen ebenso raus wie leere; die aktive bleibt immer.
   */
  function leistungsFacette(engine, basis, modus, filter) {
    var alleTreffer = zaehleMit(engine, basis, modus, filter, { min_entlade_kw: null });
    var stufen = LEISTUNGS_STUFEN
      .map(function (st) {
        return { stufe: st, treffer: zaehleMit(engine, basis, modus, filter, { min_entlade_kw: st.kw }) };
      })
      .filter(function (x) {
        if (filter.leistung === x.stufe.id) return true;
        if (x.stufe.kw === null) return true;
        return x.treffer > 0 && x.treffer < alleTreffer;
      });
    return { alleTreffer: alleTreffer, stufen: stufen };
  }

  /* Wertespanne über ein Feld — nur echte Zahlen; leere Spanne = null. */
  function spanne(werte) {
    var zahlen = werte.filter(istZahl);
    if (!zahlen.length) return null;
    return {
      min: Math.min.apply(null, zahlen),
      max: Math.max.apply(null, zahlen),
      anzahl: zahlen.length,
    };
  }

  function kapazitaetsSpanne(basis) {
    return spanne(basis.map(function (e) { return e.kapazitaet_kwh; }));
  }

  function preisProKwhSpanne(basis) {
    return spanne(basis.map(function (e) { return e.preis ? e.preis.speicher_eur_pro_kwh : null; }));
  }

  return {
    LEISTUNGS_STUFEN: LEISTUNGS_STUFEN,
    neuerFilter: neuerFilter,
    engineFilter: engineFilter,
    zaehleMit: zaehleMit,
    herstellerFacette: herstellerFacette,
    spannungsklassenImErgebnis: spannungsklassenImErgebnis,
    leistungsFacette: leistungsFacette,
    kapazitaetsSpanne: kapazitaetsSpanne,
    preisProKwhSpanne: preisProKwhSpanne,
  };
});
